<template>
  <svg viewBox="-35,-35, 70, 70">
    <defs>
      <clipPath id="clip">
        <path d="M 1,0 L 1,-100 L 100,100 L -100,100 L -100,-100 L -1,-100 L -1,0Z" />
      </clipPath>
    </defs>
    <template v-for="(row, i) in performance">
      <path v-if="j!=row.length-1"
        v-for="(saving, j) in row"
        fill="none"
        :stroke="`${colorMap(saving)}`"
        stroke-width="2"
        :d="`M ${(6+i*2+1)*Math.sin(Math.PI/180*(-7.5+j*15))} ${-(6+i*2+1)*Math.cos(Math.PI/180*(-7.5+j*15))} A ${6+i*2+1} ${6+i*2+1} ${(j*15+270) % 360} 0 1 ${(6+i*2+1)*Math.sin(Math.PI/180*(7.5+j*15))} ${-(6+i*2+1)*Math.cos(Math.PI/180*(7.5+j*15))}`"
      />
      <template v-for="(ii,i) in 11">
        <circle cx="0" cy="0" :r="6+2*i"/>
        <text x="0" :y="-5.5-2*i" text-anchor="middle">{{2*i}}</text>
      </template>
      <g v-for="i in 23" :transform="`rotate(${i*15})`" >
          <path d="M 0,-6 V -27" />
          <text x="0" y ="0.5" text-anchor="middle" :transform="`translate(0,-28.5) rotate(-${i*15})`">{{15*i}}</text>
      </g>
      <text x="0" y ="-33.5" text-anchor="middle" >Wind</text>
      <text x="0" y ="-31.5" text-anchor="middle" >speed</text>
      <text x="0" y ="-29.5" text-anchor="middle" >(m/s)</text>

      <path d="M -1.25,4 L -1.25,-1.5 A 1.25 2.5, 0, 0, 1, 1.25,-1.5 L 1.25,4 Z" stroke-width="0.1" stroke="#000000" fill="#bbbbbb"/>

      <path id="text-curve" fill="none" d="M 0,-31 A 31 31, 0, 0, 1, 31 0"/>
      <text>
        <textPath xlink:href="#text-curve" startOffset="8px">
          Wind angle (deg) ->
        </textPath>
      </text>
      <line x1="-30" y1="33.5" x2="-20" y2="33.5" :stroke="`${colorMap(-0.15)}`" stroke-width="3"/>
      <line x1="-20" y1="33.5" x2="-10" y2="33.5" :stroke="`${colorMap(-0.075)}`" stroke-width="3"/>
      <line x1="-10" y1="33.5" x2="0" y2="33.5" :stroke="`${colorMap(-0.025)}`" stroke-width="3"/>
      <line x1="0" y1="33.5" x2="10" y2="33.5" :stroke="`${colorMap(0.025)}`" stroke-width="3"/>
      <line x1="10" y1="33.5" x2="20" y2="33.5" :stroke="`${colorMap(0.075)}`" stroke-width="3"/>
      <line x1="20" y1="33.5" x2="30" y2="33.5" :stroke="`${colorMap(0.15)}`" stroke-width="3"/>

      <text x="-25" y ="34" text-anchor="middle" >&lt;-10%</text>
      <text x="-15" y ="34" text-anchor="middle" >-10 to -5%</text>
      <text x="-5" y ="34" text-anchor="middle" >-5 to 0%</text>
      <text x="5" y ="34" text-anchor="middle" >0 to 5%</text>
      <text x="15" y ="34" text-anchor="middle" >5 to 10%</text>
      <text x="25" y ="34" text-anchor="middle" >&gt;20%</text>

      <!--

        .domain([-0.1,-0.05, 0.0, 0.05, 0.1])
.range(["#808080", "#A0A0A0", "#C0C0C0", "#c3d545", "#79b752", "#33a357"]);

-->
    </template>
  </svg>
</template>

<script>
import colorMap from "../assets/ColorMap.js"

export default {
  name: "PolarPlot",
  props: {
    performance: Array
  },
  methods: {
    colorMap(value) {
      return colorMap(value);
    }
  }
}
</script>

<style scoped>
circle, g>path {
  fill:none;
  stroke-width: 0.05px;
  stroke: black;
  shape-rendering: crispEdges;
}
circle {
  clip-path: url('#clip')
}
text {
  font-size: 2px;
}
</style>